<template>
  <div class="gallery-item">
      <img :src="gallery.url" @click="goDetail"/>
      <aside>
        <h3 @click="goDetail">{{ gallery.title }}</h3>
        <div class="hr">
          <div /><div />
        </div>
        <p v-if="'album' === type" class="name">{{ gallery.name }}</p>
        <p v-if="'album' === type" class="label">
          <Tag v-for="item in gallery.labels" :label="item" :key="item.id" />
        </p>
        <p class="time">{{ gallery.time }}</p>
        <p v-if="'commodity' === type" class="price">¥{{ gallery.price }}</p>
        <button v-if="'album' === type"
                class="advisory"
                name="btn" @click="goDetail">美图先看</button>
        <a v-if="'commodity' === type"
           class="advisory"
           href="http://wpa.qq.com/msgrd?v=3&uin=3531160674&site=qq&menu=yes"
           rel="nofollow"
           target="_blank">
          立刻咨询
        </a>
      </aside>
  </div>
</template>

<script>
  import Tag from '@/components/Tag'
  const moment = require('moment');

  export default {
    name: 'GalleryItem',
    components: { Tag },
    props: {
      galleryItem: {
        type: Object,
        required: true
      }
    },
    inject: ['type'],
    computed: {
      gallery () {
        const data = this.galleryItem[this.type];

        let result = {
          url: '',
          title: '',
          name: '',
          labels: [],
          time: '',
          price: 0,
          btnText: ''
        };

        result.title = data.title;

        if ('commodity' === this.type) {
          result.url = data.coverPhoto.url;
          result.time = moment(data.createdAt * 1000).format('YYYY-MM-DD HH:mm:ss');
          result.price = data.price;
        } else if ('album' === this.type) {
          result.url = data.cover137.url;
          result.time = moment(data.realsedAt * 1000).format('YYYY-MM-DD HH:mm:ss');
          result.name = data.modelsOfAlbum[0] ? data.modelsOfAlbum[0].basic.webName : '暂无';

          let labels = data.labels ? data.labels.filter(item => {
            return item.level > 1
          }) : [];

          if (labels.length > 2 ) {
            labels = labels.slice(0, 1);
          }

          result.labels = labels;
        }

        return result
      }
    },
    methods: {
      goDetail () {
        if ('album' === this.type) {
          window.location.href = `/meinvtupian/${this.galleryItem.album.contentId}.html`
        } else {
          window.location.href = `/shop/${this.galleryItem.commodity.id}.html`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .gallery-item {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 30px;
    img {
      width: 137px;
      margin-right: 10px;
      cursor: pointer;
    }
    aside {
      width: 130px;
    }
    h3 {
      height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color: #4A4A4A;
      cursor: pointer;
    }
    .hr {
      display: flex;
      margin: 5px 0;
      :first-child {
        width: 30px;
        height: 1px;
        background-color: #F39;
      }
      :last-child {
        flex: 1;
        height: 1px;
        background-color: #4A4A4A;
      }
    }
    .name {
      font-size: 12px;
      color: #BCBCBC;
    }
    .time {
      font-size: 12px;
      font-weight: 500;
    }
    .price {
      margin-top: 20px;
      font-size: 18px;
      font-weight: bold;
      color: #F39;
    }
    .advisory {
      display: inline-block;
      width: 112px;
      height: 30px;
      margin-top: 20px;
      border: solid 1px #cecece;
      border-radius: 20px;
      text-align: center;
      line-height: 30px;
      color: #FF2F86;;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
    }
    .advisory:hover {
      border: none;
      background-color: #F39;
      color: #FFF;
    }
  }
  .gallery-item:hover img {
    -webkit-filter: brightness(90%);
    filter: brightness(90%);
  }
  .gallery-item:hover h3 {
    color:  #FF3399;
  }
</style>





// WEBPACK FOOTER //
// src/components/GalleryItem.vue